import { render, staticRenderFns } from "./bannerCarousel.vue?vue&type=template&id=f9c28d80&scoped=true"
import script from "./bannerCarousel.vue?vue&type=script&lang=js"
export * from "./bannerCarousel.vue?vue&type=script&lang=js"
import style0 from "./bannerCarousel.vue?vue&type=style&index=0&id=f9c28d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c28d80",
  null
  
)

export default component.exports